import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import {
  IEventoGenerico,
  IQueryParam,
  IFilter,
  IUbicacion,
  IUpdateEventoGenerico,
} from 'modelos/src';
import { debounceTime, firstValueFrom, Subject, Subscription } from 'rxjs';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { EventosGenericosHttpService } from '../../../../auxiliares/servicios/http/eventos-genericos.service';
import { Router } from '@angular/router';
import { SegmentadoCambio } from '../../../../componentes/botones';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TratamientoGenericoComponent } from '../tratar-evento-generico/tratamiento-generico/tratamiento-generico.component';
import { TratamientoGrupalComponent } from '../tratar-evento-generico/tratamiento-grupal/tratamiento-grupal.component';
import { FiltroPersonalizadoComponent } from './filtro-personalizado/filtro-personalizado.component';
import { EventosGenericosHelperService } from '../helper';
import { ListadoEventosGenericosVivoService } from '../../../../auxiliares/servicios/listado-eventos-genericos-vivo';
import { UbicacionService } from '../../../../auxiliares/servicios/http/ubicacion.service';
import { AlarmasDomiciliariasService } from '../../alarmas/alarmas-domiciliarias/alarmas-domiciliarias.service';
import { ActivosService } from '../../../../auxiliares/servicios/http/activos.service';
import {
  CRITERIOS_AGRUPACION,
  CriterioAgrupacion,
  IFiltroAgrupamientoPersonalizado,
  TIPOS_EVENTO_CON_PUNTO_PROPIO,
  construirClausulaZona,
  construirFiltroMongo,
  zonaAplicaATipoEvento,
  filtroEstaVacio,
  guardarCriterio,
  guardarFiltro,
  leerCriterioGuardado,
  leerFiltroGuardado,
} from '../agrupamiento-personalizado';
import * as turf from '@turf/turf';
import {
  fechaCelda,
  haceCelda,
  textoSobre,
} from '../../../../auxiliares/tabla/celdas';
import { colorSeguro } from '../../../../auxiliares/html-seguro.util';
import { IEstadoCelda } from '../../../../auxiliares/tabla/tabla.interfaces';

/** Fecha con segundos (24 h, huso del navegador) para el tooltip de Fecha. */
const FORMATO_SEGUNDOS = new Intl.DateTimeFormat('es-AR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

/** Clave del grupo de eventos que no caen en ninguna zona. */
const SIN_ZONA = '__sin_zona__';

@Component({
  selector: 'app-eventos-genericos-vivos',
  templateUrl: './eventos-genericos-vivos.component.html',
  styleUrls: ['./eventos-genericos-vivos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EventosGenericosVivosComponent implements OnInit, OnDestroy {
  private formularios = inject(FormularioDialogService);
  private lista2Service = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private cdr = inject(ChangeDetectorRef);
  private router = inject(Router);
  dialog = inject(MatDialog);
  eventosHelper = inject(EventosGenericosHelperService);
  private eventosGenericosService = inject(EventosGenericosHttpService);
  private listadoVivoService = inject(ListadoEventosGenericosVivoService);
  private ubicacionService = inject(UbicacionService);
  private alarmasService = inject(AlarmasDomiciliariasService);
  private activosService = inject(ActivosService);

  public loading = true;
  public modoAgrupacion =
    localStorage.getItem('modoAgrupacionGenericos') || '2';
  public categorias: {
    nombre: string;
    color: string;
    prioridad: number;
    colorTexto: string;
  }[] = [];
  public entidades: { nombre: string }[] = [];
  public tiposEntidades: { nombre: string }[] = [];
  public clientes: { nombre: string }[] = [];
  public eventosPorCategoria: { [key: string]: IEventoGenerico[] } = {};
  public eventosPorEntidad: { [key: string]: IEventoGenerico[] } = {};
  public eventosPorTipoEntidad: { [key: string]: IEventoGenerico[] } = {};
  public eventosPorCliente: { [key: string]: IEventoGenerico[] } = {};

  // ── Agrupamiento personalizado (modo '6') ─────────────────────────────────
  /** Filtro que va al SERVIDOR, persistido en localStorage */
  public filtroPersonalizado: IFiltroAgrupamientoPersonalizado =
    leerFiltroGuardado();
  public criterio: CriterioAgrupacion = leerCriterioGuardado();
  public readonly criterios = CRITERIOS_AGRUPACION;
  /**
   * Buckets del modo personalizado. La `clave` es el valor que se puede mandar
   * al SERVIDOR (un id, una categoria); el `label` es lo que ve el operador.
   * Agrupar por nombre alcanzaria para pintar la card pero no para finalizar el
   * grupo por filtro, que es lo unico correcto cuando el listado esta truncado.
   */
  public gruposPersonalizados: { clave: string; label: string }[] = [];
  public eventosPorGrupo: { [clave: string]: IEventoGenerico[] } = {};
  private labelPorClave = new Map<string, string>();
  /** Total real en la base; si supera lo cargado, el listado está truncado */
  public totalCountPersonalizado = 0;
  public cargadosPersonalizado = 0;
  private personalizado$?: Subscription;
  /** Zonas con polígono, para el criterio 'zona' y para el filtro por zona */
  public zonasDisponibles: IUbicacion[] = [];
  /**
   * idEntidad -> _id de zona, para las entidades FIJAS (alarma): sus eventos no
   * traen punto propio (medido en prod: 0%), asi que la zona se resuelve por la
   * ubicacion de la entidad y se cachea aca.
   */
  private zonaPorEntidad = new Map<string, string>();

  public panelExpanded: string;

  public esClienteZero = this.helper.esNivel0();
  /** Se resuelve una sola vez: `tienePermiso` recorre todos los roles */
  public puedeFinalizar = this.helper.tienePermiso(
    'Eventos - Finalizar eventos',
  );

  /** Caches para no recalcular lo mismo en cada ciclo de detección de cambios */
  private cacheBusqueda = new WeakMap<IEventoGenerico, string>();
  private cacheEntidadInfo = new WeakMap<
    IEventoGenerico,
    { icono: string; texto: string } | null
  >();
  private busqueda$ = new Subject<void>();
  private busquedaSub?: Subscription;

  public eventos: IEventoGenerico[] = [];
  public eventosFiltrados: IEventoGenerico[] = [];
  public eventos$?: Subscription;
  public totalCount = 0;
  public searchTerm: string = '';
  public searchExpanded: boolean = false;

  public columnas =
    this.tipoCliente() === 'Final'
      ? [
          'categoria',
          'evento',
          'detallesEvento',
          'entidad',
          'estado',
          'fecha',
          'repetido',
          'acciones',
        ]
      : [
          'categoria',
          'evento',
          'detallesEvento',
          'entidad',
          'estado',
          'cliente',
          'fecha',
          'repetido',
          'acciones',
        ];
  public columnasAgrupadoCategoria =
    this.tipoCliente() === 'Final'
      ? [
          'evento',
          'detallesEvento',
          'entidad',
          'estado',
          'fecha',
          'repetido',
          'acciones',
        ]
      : [
          'evento',
          'detallesEvento',
          'entidad',
          'estado',
          'cliente',
          'fecha',
          'repetido',
          'acciones',
        ];
  public columnasAgrupadoEntidad =
    this.tipoCliente() === 'Final'
      ? [
          'categoria',
          'evento',
          'detallesEvento',
          'estado',
          'fecha',
          'acciones',
          'repetido',
        ]
      : [
          'categoria',
          'evento',
          'detallesEvento',
          'estado',
          'cliente',
          'fecha',
          'repetido',
          'acciones',
        ];
  public columnasAgrupadoTipoEntidad =
    this.tipoCliente() === 'Final'
      ? [
          'categoria',
          'evento',
          'detallesEvento',
          'entidad',
          'estado',
          'fecha',
          'acciones',
          'repetido',
        ]
      : [
          'categoria',
          'evento',
          'detallesEvento',
          'entidad',
          'estado',
          'cliente',
          'fecha',
          'repetido',
          'acciones',
        ];
  public columnasAgrupadoCliente = [
    'categoria',
    'evento',
    'detallesEvento',
    'entidad',
    'estado',
    'fecha',
    'repetido',
    'acciones',
  ];

  public query: IQueryParam = {
    page: 0,
    sort: '-fechaCreacion',
    includeChildren: true,
  };

  public tipoCliente() {
    return HelperService.getTipoCliente();
  }

  /**
   * Identidad de fila para mat-table. Cada refresco trae objetos nuevos del
   * backend: sin esto se destruyen y recrean todas las filas cada 90s.
   */
  public trackPorId = (_indice: number, evento: IEventoGenerico) => evento._id;

  /** Nombre de la entidad del evento, con la misma precedencia de siempre */
  private nombreEntidad(e: IEventoGenerico): string | undefined {
    return (
      e.alarma?.nombre ||
      e.activo?.identificacion ||
      e.luminaria?.identificacion ||
      e.gateway?.nombre ||
      e.botonBluetooth?.mac ||
      e.sirena?.chipId ||
      e.tracker?.identificacion
    );
  }

  /** Tipos de entidad (módulo) a los que pertenece un evento */
  private tiposDeEntidad(e: IEventoGenerico): string[] {
    const tipos: string[] = [];
    if (e.luminaria?._id) tipos.push('Luminaria');
    if (e.gateway?._id) tipos.push('Gateway');
    if (e.alarma?._id) tipos.push('Alarma');
    if (e.activo?._id) {
      const categoria = e.activo.categoria;
      tipos.push(categoria && categoria !== 'Normal' ? categoria : 'Activo');
    }
    if (e.botonBluetooth?._id) tipos.push('Botón BLE');
    if (e.sirena?._id) tipos.push('Sirena');
    if (e.tracker?._id) tipos.push('Tracker');
    return tipos;
  }

  /**
   * Bucketea en una sola pasada. `claveFn` devuelve la clave del evento, o
   * varias si el evento cae en más de un bucket (el caso de tipo de entidad),
   * o nada para dejarlo afuera.
   *
   * Único mecanismo de agrupación del listado: los 4 modos históricos y el
   * personalizado pasan por acá, así que agregar un criterio es escribir una
   * función `(evento) => clave` y nada más.
   */
  private agruparPorClave(
    data: IEventoGenerico[],
    claveFn: (e: IEventoGenerico) => string | string[] | undefined,
  ): Map<string, IEventoGenerico[]> {
    const buckets = new Map<string, IEventoGenerico[]>();
    for (const e of data) {
      const clave = claveFn(e);
      if (!clave) continue;
      const claves = Array.isArray(clave) ? clave : [clave];
      for (const k of claves) {
        if (!k) continue;
        const bucket = buckets.get(k);
        if (bucket) bucket.push(e);
        else buckets.set(k, [e]);
      }
    }
    return buckets;
  }

  private agruparEventosPorEntidad(data: IEventoGenerico[]) {
    try {
      const buckets = this.agruparPorClave(data, (e) => this.nombreEntidad(e));

      this.entidades = [...buckets.keys()]
        .sort((a, b) => a.localeCompare(b))
        .map((nombre) => ({ nombre }));
      this.eventosPorEntidad = Object.fromEntries(buckets);
    } catch (error) {
      console.error('Error al agrupar eventos por entidad:', error);
    }
  }

  private agruparEventosPorCategoria(data: IEventoGenerico[]) {
    try {
      // Usamos categoria (nombre de la categoría) o tipoEvento como fallback
      const buckets = this.agruparPorClave(
        data,
        (e) => e.categoria || e.tipoEvento,
      );
      // color/prioridad del primer evento de cada bucket, como antes
      const metadatos = new Map<string, { color: string; prioridad: number }>();
      for (const [nombre, eventos] of buckets) {
        const primero = eventos[0] as any;
        metadatos.set(nombre, {
          color: primero?.valores?.color,
          prioridad: primero?.prioridad || 0,
        });
      }

      this.categorias = [...buckets.keys()]
        .map((nombre) => {
          const meta = metadatos.get(nombre);
          return {
            nombre,
            color: meta.color,
            prioridad: meta.prioridad,
            colorTexto: this.helper.colorDeTextoSegunColor(meta.color),
          };
        })
        .sort((a, b) => a.prioridad - b.prioridad);
      this.eventosPorCategoria = Object.fromEntries(buckets);
    } catch (error) {
      console.error('Error al agrupar eventos por categoria:', error);
    }
  }

  private agruparEventosPorTipoEntidad(data: IEventoGenerico[]) {
    try {
      // Un evento puede caer en más de un tipo (igual que antes)
      const buckets = this.agruparPorClave(data, (e) => this.tiposDeEntidad(e));

      this.tiposEntidades = [...buckets.keys()]
        .sort()
        .map((nombre) => ({ nombre }));
      this.eventosPorTipoEntidad = Object.fromEntries(buckets);
    } catch (error) {
      console.error('Error al agrupar eventos por tipo de entidad:', error);
    }
  }

  private agruparEventosPorCliente(data: IEventoGenerico[]) {
    try {
      const buckets = this.agruparPorClave(data, (e) => e.cliente?.nombre);

      this.clientes = [...buckets.keys()]
        .sort((a, b) => a.localeCompare(b))
        .map((nombre) => ({ nombre }));
      this.eventosPorCliente = Object.fromEntries(buckets);
    } catch (error) {
      console.error('Error al agrupar eventos por cliente:', error);
    }
  }

  // -- Agrupamiento personalizado --------------------------------------------

  /** Zonas (IUbicacion con poligono) de las categorias que las usan */
  private async cargarZonasDisponibles(): Promise<void> {
    if (this.zonasDisponibles.length) return;
    // Solo las categorias que hoy pueden matchear algo. 'Activos' queda afuera
    // a proposito: sus eventos no traen punto (0% medido en prod) y IActivo no
    // tiene FK a una ubicacion, asi que una zona de activos no matchearia nunca
    // y seria una opcion que no hace nada. Ver TIPOS_EVENTO_POR_CATEGORIA_ZONA.
    const filter = {
      categoria: {
        $in: ['Alarmas', 'Luminarias', 'Vehiculos', 'Terminal'],
      },
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      select: 'identificacion color geojson categoria idCliente',
      sort: 'identificacion',
      unlimited: true,
      includeChildren: true,
    };
    try {
      const res = await this.ubicacionService.getFiltered(query);
      this.zonasDisponibles = ((res.datos ?? []) as IUbicacion[]).filter(
        (z) =>
          z.geojson?.type === 'Polygon' || z.geojson?.type === 'MultiPolygon',
      );
    } catch (error) {
      console.error('Error cargando zonas', error);
      this.zonasDisponibles = [];
    }
  }

  /**
   * Entidades FIJAS dentro de las zonas elegidas. Hoy solo alarmas: son las
   * unicas con una ubicacion propia persistida (idDomicilio). Los eventos de
   * activo tampoco traen punto (0% medido en prod) pero IActivo no tiene FK a
   * una ubicacion -- su posicion sale del ultimo trackeo --, asi que quedan
   * fuera del filtro por zona hasta que se decida resolverlos por reporte.
   *
   * Devuelve los ids para el filtro del servidor y llena zonaPorEntidad, que
   * es lo que despues usa el bucket del criterio 'zona'.
   */
  private async resolverEntidadesEnZonas(
    idsZonas: string[],
  ): Promise<string[]> {
    this.zonaPorEntidad.clear();
    // Solo las zonas de alarmas resuelven alarmas: una zona de luminarias que
    // contenga domicilios no dice nada sobre esas alarmas.
    const zonas = this.zonasDisponibles.filter(
      (z) => z._id && idsZonas.includes(z._id) && z.categoria === 'Alarmas',
    );
    if (!zonas.length) return [];

    const ids: string[] = [];
    for (const zona of zonas) {
      try {
        // Domicilios dentro del poligono. Sale por los indices 2dsphere
        // compuestos que ya tiene la coleccion ubicacions.
        const filtroUbi = {
          categoria: 'Domicilio',
          geojson: { $geoWithin: { $geometry: zona.geojson } },
        };
        const domicilios = await this.ubicacionService.getFiltered({
          filter: JSON.stringify(filtroUbi),
          select: '_id',
          unlimited: true,
          includeChildren: true,
        });
        const idsDomicilio = (domicilios.datos ?? []).map((u) => u._id);
        if (!idsDomicilio.length) continue;

        const alarmas = await this.alarmasService.getFiltered({
          filter: JSON.stringify({ idDomicilio: { $in: idsDomicilio } }),
          select: '_id',
          unlimited: true,
          includeChildren: true,
        });
        for (const alarma of alarmas.datos ?? []) {
          ids.push(alarma._id);
          this.zonaPorEntidad.set(alarma._id, zona._id);
        }
      } catch (error) {
        // Un poligono auto-intersectado hace fallar el $geoWithin con
        // "Loop is not valid": se saltea esa zona en vez de vaciar el listado.
        console.error(
          'No se pudieron resolver las entidades de la zona',
          zona.identificacion,
          error,
        );
      }
    }
    return ids;
  }

  /** Zona de un evento para el bucket. Dos caminos, ver el plan. */
  private claveZona(e: IEventoGenerico): string | undefined {
    const coords = (e.valores as { geojson?: { coordinates?: number[] } })
      ?.geojson?.coordinates;
    // Entidades moviles: el punto del EVENTO, no la posicion actual
    if (
      TIPOS_EVENTO_CON_PUNTO_PROPIO.includes(e.tipoEvento) &&
      coords?.length >= 2 &&
      (coords[0] || coords[1])
    ) {
      const punto = turf.point([coords[0], coords[1]]);
      const zona = this.zonasDisponibles.find((z) => {
        // La zona tiene que ser del modulo del evento: un evento de gateway que
        // cae dentro de una zona de alarmas no pertenece a esa zona.
        if (!zonaAplicaATipoEvento(z.categoria, e.tipoEvento)) return false;
        try {
          return turf.booleanPointInPolygon(
            punto,
            z.geojson as GeoJSON.Polygon | GeoJSON.MultiPolygon,
          );
        } catch {
          return false;
        }
      });
      return zona?._id;
    }
    // Entidades fijas: por la ubicacion de la entidad
    return this.zonaPorEntidad.get(e.idEntidad);
  }

  /** Clave de bucket segun el criterio elegido */
  private claveDelCriterio(e: IEventoGenerico): string | string[] | undefined {
    switch (this.criterio) {
      case 'zona':
        // Sin zona no es "fuera del listado": va a su propio grupo.
        return this.claveZona(e) ?? SIN_ZONA;
      case 'cliente':
        return e.idCliente;
      case 'categoria':
        return e.categoria || e.tipoEvento;
      case 'tipoEntidad':
        return this.tiposDeEntidad(e);
      case 'entidad':
        return e.idEntidad;
      case 'prioridad':
        return e.prioridad != null ? String(e.prioridad) : undefined;
      default:
        return undefined;
    }
  }

  /** Texto visible de un bucket, a partir de un evento que cayo adentro */
  private labelDelCriterio(clave: string, e: IEventoGenerico): string {
    switch (this.criterio) {
      case 'zona':
        return (
          this.zonasDisponibles.find((z) => z._id === clave)?.identificacion ||
          'Sin zona'
        );
      case 'cliente':
        return e.cliente?.nombre || 'Sin cliente';
      case 'entidad':
        return this.nombreEntidad(e) || 'Sin dispositivo';
      case 'prioridad':
        return 'Prioridad ' + clave;
      default:
        return clave;
    }
  }

  private agruparPersonalizado(data: IEventoGenerico[]): void {
    try {
      const buckets = this.agruparPorClave(data, (e) =>
        this.claveDelCriterio(e),
      );
      this.labelPorClave.clear();
      for (const [clave, eventos] of buckets) {
        this.labelPorClave.set(clave, this.labelDelCriterio(clave, eventos[0]));
      }
      this.gruposPersonalizados = [...buckets.keys()]
        .map((clave) => ({ clave, label: this.labelPorClave.get(clave) }))
        .sort(
          (a, b) =>
            Number(a.clave === SIN_ZONA) - Number(b.clave === SIN_ZONA) ||
            a.label.localeCompare(b.label),
        );
      this.eventosPorGrupo = Object.fromEntries(buckets);
    } catch (error) {
      console.error('Error al agrupar (personalizado):', error);
    }
  }

  /**
   * Clausula Mongo que aisla un bucket, para poder finalizar/tratar el grupo
   * COMPLETO y no solo lo que entro en la pagina. Devuelve null cuando el
   * criterio no es expresable del lado del servidor; ahi el llamador cae a la
   * lista de ids y avisa si el listado esta truncado.
   */
  private clausulaDelGrupo(clave: string): Record<string, unknown> | null {
    switch (this.criterio) {
      case 'cliente':
        return { idCliente: clave };
      case 'categoria':
        return { categoria: clave };
      case 'entidad':
        return { idEntidad: clave };
      case 'prioridad':
        return { prioridad: Number(clave) };
      case 'zona': {
        const zona = this.zonasDisponibles.find((z) => z._id === clave);
        if (!zona) return null;
        const idsFijas = [...this.zonaPorEntidad.entries()]
          .filter(([, idZona]) => idZona === clave)
          .map(([idEntidad]) => idEntidad);
        return construirClausulaZona({ idsZonas: [clave] }, [zona], idsFijas);
      }
      // 'tipoEntidad' agrupa por modulo y un mismo tipoEvento puede caer en
      // varios (las categorias de activo), asi que no hay clausula fiel.
      default:
        return null;
    }
  }

  /**
   * Pide los eventos con el filtro aplicado del lado del SERVIDOR. No reusa el
   * array del listado vivo: ese esta capado en 1000 y filtrarlo en memoria
   * agruparia una fraccion arbitraria sin avisar.
   */
  public async listarPersonalizado(): Promise<void> {
    await this.cargarZonasDisponibles();

    const idsEntidadesEnZona = this.filtroPersonalizado.idsZonas?.length
      ? await this.resolverEntidadesEnZonas(this.filtroPersonalizado.idsZonas)
      : undefined;
    // Agrupar por zona sin filtrar por zona también necesita saber en qué
    // zona está cada alarma (sus eventos no traen punto); no filtra nada.
    if (!idsEntidadesEnZona && this.criterio === 'zona') {
      await this.resolverZonasDeTodasLasAlarmas();
    }

    const filtroExtra = construirFiltroMongo(
      this.filtroPersonalizado,
      this.zonasDisponibles,
      idsEntidadesEnZona,
    );

    this.personalizado$?.unsubscribe();
    this.personalizado$ = this.lista2Service
      .eventosGenericosVivoFiltrado(filtroExtra, 30)
      .subscribe({
        next: (data) => {
          this.eventos = data.datos ?? [];
          this.cargadosPersonalizado = this.eventos.length;
          this.totalCountPersonalizado = data.totalCount ?? this.eventos.length;
          this.aplicarFiltro();
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error('Error listando eventos (personalizado)', error);
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }

  /** true si la base tiene mas eventos que los que se pudieron traer */
  public get truncadoPersonalizado(): boolean {
    return this.totalCountPersonalizado > this.cargadosPersonalizado;
  }

  /** Texto del criterio activo para el boton de la barra */
  public get labelCriterio(): string {
    return (
      CRITERIOS_AGRUPACION.find((c) => c.valor === this.criterio)?.label ?? ''
    );
  }

  public get filtroPersonalizadoVacio(): boolean {
    return filtroEstaVacio(this.filtroPersonalizado);
  }

  public async cambiarCriterio(criterio: CriterioAgrupacion): Promise<void> {
    this.criterio = criterio;
    guardarCriterio(criterio);
    if (criterio === 'zona' && !this.filtroPersonalizado.idsZonas?.length) {
      await this.resolverZonasDeTodasLasAlarmas();
    }
    this.agruparPersonalizado(this.eventosFiltrados);
    this.cdr.markForCheck();
  }

  /** Ubica cada alarma en su zona de alarmas, sin filtrar el listado. */
  private async resolverZonasDeTodasLasAlarmas(): Promise<void> {
    if (!this.zonasDisponibles.length) await this.cargarZonasDisponibles();
    const idsZonasAlarmas = this.zonasDisponibles
      .filter((z) => z._id && z.categoria === 'Alarmas')
      .map((z) => z._id);
    await this.resolverEntidadesEnZonas(idsZonasAlarmas);
  }

  /** Solo agrupa según el modo visible: antes se calculaban los 4 siempre */
  private reagrupar(): void {
    const data = this.eventosFiltrados;
    switch (this.modoAgrupacion) {
      case '2':
        this.agruparEventosPorCategoria(data);
        break;
      case '3':
        this.agruparEventosPorEntidad(data);
        break;
      case '4':
        this.agruparEventosPorTipoEntidad(data);
        break;
      case '5':
        this.agruparEventosPorCliente(data);
        break;
      case '6':
        this.agruparPersonalizado(data);
        break;
      default:
        // '1' = sin agrupar, se usa eventosFiltrados directo
        break;
    }
  }

  public async listar(): Promise<void> {
    return new Promise((resolve) => {
      this.eventos$?.unsubscribe();
      if (this.listadoVivoService.eventos?.length) {
        this.procesarEventos(this.listadoVivoService.eventos);
        resolve();
      }
      this.eventos$ = this.listadoVivoService.eventosChange.subscribe(
        (data) => {
          this.procesarEventos(data);
          resolve();
        },
      );
    });
  }

  private procesarEventos(data: IEventoGenerico[]): void {
    this.totalCount = data.length;
    this.eventos = data;
    // aplicarFiltro ya reagrupa: antes se agrupaba dos veces por refresh
    this.aplicarFiltro();
    this.loading = false;
    this.cdr.markForCheck();
  }

  /**
   * Texto de búsqueda del evento, cacheado por objeto. El stringify se hace
   * una sola vez por evento y no en cada tecla.
   */
  private textoBusqueda(evento: IEventoGenerico): string {
    let texto = this.cacheBusqueda.get(evento);
    if (texto === undefined) {
      try {
        texto = JSON.stringify(evento).toLowerCase();
      } catch (error) {
        console.error('Error al indexar evento para búsqueda:', error);
        texto = '';
      }
      this.cacheBusqueda.set(evento, texto);
    }
    return texto;
  }

  /** Entrada del buscador: se filtra con debounce, no en cada tecla */
  public onSearchChange(): void {
    this.busqueda$.next();
  }

  public aplicarFiltro(): void {
    const termino = this.searchTerm?.toLowerCase().trim();
    if (!termino) {
      this.eventosFiltrados = this.eventos;
    } else {
      this.eventosFiltrados = this.eventos.filter((evento) =>
        this.textoBusqueda(evento).includes(termino),
      );
    }

    this.reagrupar();
    this.cdr.markForCheck();
  }

  public async cambioFiltro() {
    this.loading = true;
    await this.listar();
  }

  public ajustarDireccion(text: string) {
    if (!text) return '';
    if (text.length >= 50) {
      text = text.slice(0, 50);
      text += '...';
    }
    return text;
  }

  public sonFechasIguales(isoFecha1: string, isoFecha2: string): boolean {
    if (!isoFecha1 || !isoFecha2) return true;
    const f1 = isoFecha1.slice(0, 16);
    const f2 = isoFecha2.slice(0, 16);
    return f1 === f2;
  }

  /**
   * Color de la categoría para su badge (validado); null si falta o no es
   * válido, y entonces el badge queda neutro.
   */
  public colorCategoria(e: IEventoGenerico): string | null {
    return colorSeguro(e.valores?.color, '') || null;
  }

  /** Texto legible sobre el color de la categoría (blanco u oscuro). */
  public textoCategoria(e: IEventoGenerico): string | null {
    const c = this.colorCategoria(e);
    return c ? textoSobre(c) : null;
  }

  public getBackgroundColor(e: IEventoGenerico) {
    return `background-color: ${e.valores?.color}`;
  }

  // Fechas con el formato común de los listados (24 h, huso del navegador)
  public fechaCelda = fechaCelda;
  public haceCelda = haceCelda;

  /** Estado del evento como píldora (ícono + nombre real + tono) */
  public estadoEvento(estado?: string): IEstadoCelda | undefined {
    return EventosGenericosHelperService.estadoEvento(estado);
  }

  /** Fechas exactas, con segundos, en el tooltip de la celda Fecha */
  public tooltipFecha(e: IEventoGenerico): string {
    const partes = [
      `Creado: ${FORMATO_SEGUNDOS.format(new Date(e.fechaCreacion))}`,
    ];
    if (
      e.fechaUltimoRepetido &&
      !this.sonFechasIguales(e.fechaCreacion, e.fechaUltimoRepetido)
    ) {
      partes.push(
        `Última repetición: ${FORMATO_SEGUNDOS.format(new Date(e.fechaUltimoRepetido))}`,
      );
    }
    return partes.join(' · ');
  }

  /** Nombres de los operadores que están atendiendo el evento (tooltip) */
  public nombresAtendiendo(e: IEventoGenerico): string {
    return (e.usuariosAtendiendo || [])
      .map((u) => u?.datosPersonales?.nombre || u?.usuario)
      .filter(Boolean)
      .join(', ');
  }

  public async cambioModoAgrupacion(modo: SegmentadoCambio) {
    localStorage.setItem('modoAgrupacionGenericos', modo.value);
    this.modoAgrupacion = modo.value;

    // El modo personalizado NO comparte la fuente de datos con los otros: pide
    // los eventos filtrados al servidor, en vez de bucketear el array del
    // listado vivo (capado en 1000).
    if (modo.value === '6') {
      this.loading = true;
      this.eventos$?.unsubscribe();
      await this.listarPersonalizado();
      return;
    }
    this.personalizado$?.unsubscribe();
    this.personalizado$ = undefined;
    if (!this.eventos$) {
      this.loading = true;
      await this.listar();
      return;
    }
    // Solo se agrupa el modo activo, así que hay que rearmarlo al cambiar
    this.reagrupar();
    this.cdr.markForCheck();
  }

  /** Abre el editor del filtro y recarga si cambió */
  public async editarFiltroPersonalizado(): Promise<void> {
    await this.cargarZonasDisponibles();
    const dialogRef = this.formularios.abrir(FiltroPersonalizadoComponent, {
      tamano: 'grande',
      data: {
        filtro: this.filtroPersonalizado,
        zonas: this.zonasDisponibles,
      },
    });
    const res: IFiltroAgrupamientoPersonalizado | undefined =
      await firstValueFrom(dialogRef.afterClosed());
    if (!res) return;
    this.filtroPersonalizado = res;
    guardarFiltro(res);
    this.loading = true;
    await this.listarPersonalizado();
  }

  public onSearchBlur(): void {
    // Solo contraer si no hay texto en el buscador
    if (!this.searchTerm) {
      setTimeout(() => {
        this.searchExpanded = false;
      }, 200);
    }
  }

  public irADetalles(evento: IEventoGenerico) {
    if (evento?.alarma?._id) {
      this.router.navigate([
        `main/alarmas/alarmasDomiciliarias/detallesAlarma/${evento.alarma._id}`,
      ]);
      return;
    }
    if (evento?.luminaria?._id) {
      this.router.navigate([
        `main/luminarias/luminarias/detalles/${evento.luminaria._id}`,
      ]);
      return;
    }
    if (evento?.gateway?._id) {
      this.router.navigate([
        `main/administracion/gateways/detalles/${evento.gateway._id}`,
      ]);
      return;
    }
    if (evento?.activo?._id) {
      //ACTIVO TIPO VEHÍCULO
      if (evento.activo.categoria === 'Vehículo' && evento.activo.vehiculo) {
        this.router.navigate([
          `main/vehiculos/vehiculos/detalles/${evento.activo._id}`,
        ]);
        return;
      } else if (
        evento.activo.categoria === 'Colectivo' &&
        evento.activo.vehiculo
      ) {
        this.router.navigate([
          `main/colectivos/colectivos/detalles/${evento.activo._id}`,
        ]);
        return;
      } else {
        this.router.navigate([
          `main/activos/activos/detalles/${evento.activo._id}`,
        ]);
        return;
      }
    }
    if (evento.sirena?._id) {
      this.router.navigate([
        `main/sirenas/sirenas/detalles/${evento.sirena._id}`,
      ]);
      return;
    }
  }

  public async tratar(evento: IEventoGenerico) {
    const config: MatDialogConfig = {
      data: { idEvento: evento._id },
      hasBackdrop: false,
      minWidth: '800px',
      maxWidth: '1000px',
      closeOnNavigation: false,
      disableClose: true,
    };

    const dialogRef = this.dialog.open(TratamientoGenericoComponent, config);
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      // Recargar listado después de tratar
      await this.listadoVivoService.forceRefresh();
    }
  }

  public async finalizarTodosPorTipo(tipo: string) {
    const confirm = await this.dialogService.confirm(
      'Finalizar eventos',
      `
      ¿Querés finalizar todos los eventos de tipo ${tipo}?`,
    );
    if (!confirm) return;
    const eventos = this.eventosPorTipoEntidad[tipo];
    const idsEventos = eventos.map((e) => e._id);
    await this.finalizarTodos(idsEventos);
  }

  public async finalizarTodosPorEntidad(entidad: string) {
    const confirm = await this.dialogService.confirm(
      'Finalizar eventos',
      `
      ¿Querés finalizar todos los eventos de ${entidad}?
      No se crearán tratamientos asociados a estos eventos.`,
    );
    if (!confirm) return;
    const eventos = this.eventosPorEntidad[entidad];
    const idsEventos = eventos.map((e) => e._id);
    await this.finalizarTodos(idsEventos);
  }

  public async finalizarTodosPorCategoria(categoria: string) {
    const confirm = await this.dialogService.confirm(
      'Finalizar eventos',
      `
      ¿Querés finalizar todos los eventos de la categoría ${categoria}?
      No se crearán tratamientos asociados a estos eventos.`,
    );
    if (!confirm) return;
    const eventos = this.eventosPorCategoria[categoria];
    const idsEventos = eventos.map((e) => e._id);
    await this.finalizarTodos(idsEventos);
  }

  public async finalizarTodosPorCliente(cliente: string) {
    const confirm = await this.dialogService.confirm(
      'Finalizar eventos',
      `
      ¿Querés finalizar todos los eventos del cliente ${cliente}?
      No se crearán tratamientos asociados a estos eventos.`,
    );
    if (!confirm) return;
    const eventos = this.eventosPorCliente[cliente];
    const idsEventos = eventos.map((e) => e._id);
    await this.finalizarTodos(idsEventos);
  }

  // -- Acciones masivas del modo personalizado -------------------------------

  /** Filtro (base + personalizado + grupo) de un bucket, o null si no se puede */
  private queryDelGrupo(clave: string): IQueryParam | null {
    const clausula = this.clausulaDelGrupo(clave);
    if (!clausula) return null;
    const filtroExtra = construirFiltroMongo(
      this.filtroPersonalizado,
      this.zonasDisponibles,
      [...this.zonaPorEntidad.keys()],
    );
    const and = ((filtroExtra as Record<string, unknown>)['$and'] ??
      []) as unknown[];
    (filtroExtra as Record<string, unknown>)['$and'] = [...and, clausula];
    return this.lista2Service.queryVivo(filtroExtra);
  }

  /** Cuenta real en la base, para no confirmar sobre el numero de la pagina */
  private async contarDelGrupo(query: IQueryParam): Promise<number> {
    const res = await this.eventosGenericosService.getFiltered({
      ...query,
      limit: 1,
    });
    return res.totalCount ?? 0;
  }

  /**
   * Finaliza el grupo COMPLETO cuando el criterio es expresable como filtro; si
   * no lo es, cae a los ids de la pagina y avisa que puede quedar afuera lo que
   * el listado no trajo.
   */
  public async finalizarGrupo(grupo: {
    clave: string;
    label: string;
  }): Promise<void> {
    const query = this.queryDelGrupo(grupo.clave);
    const eventos = this.eventosPorGrupo[grupo.clave] ?? [];

    if (!query) {
      const aviso = this.truncadoPersonalizado
        ? `\n\nOJO: se finalizan los ${eventos.length} eventos cargados. Este criterio de agrupación no se puede resolver del lado del servidor, y el listado está truncado (${this.totalCountPersonalizado} en total), así que puede quedar afuera lo que no se trajo.`
        : '';
      const confirm = await this.dialogService.confirm(
        'Finalizar eventos',
        `Se van a finalizar ${eventos.length} eventos de "${grupo.label}". No se crearán tratamientos asociados.${aviso}`,
      );
      if (!confirm) return;
      await this.finalizarTodos(eventos.map((e) => e._id));
      return;
    }

    let total: number;
    try {
      total = await this.contarDelGrupo(query);
    } catch (error) {
      console.error('No se pudo contar el grupo', error);
      this.helper.notifError(error);
      return;
    }
    if (!total) {
      this.helper.notifWarn('No hay eventos para finalizar');
      return;
    }
    const confirm = await this.dialogService.confirm(
      'Finalizar eventos',
      `Se van a finalizar ${total} eventos de "${grupo.label}". No se crearán tratamientos asociados.`,
    );
    if (!confirm) return;

    try {
      this.loading = true;
      // `any` como en finalizarTodos: IUpdateEventoGenerico es una union
      // discriminada que exige `tipoEvento`, y este update es parcial y cruza
      // varios tipos de evento a la vez.
      const update: any = { estado: 'Finalizada' };
      await this.eventosGenericosService.updateMany2(query, update);
      this.helper.notifSuccess('Eventos finalizados correctamente');
      await this.listarPersonalizado();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    } finally {
      this.loading = false;
    }
  }

  /**
   * Tratamiento grupal: un solo ITratamientoEvento con los eventos del grupo
   * (idsEventos ya es array en el modelo). Deja mensaje y estado, sin ficha de
   * entidad: un grupo por zona mezcla dispositivos distintos.
   */
  public async tratarGrupo(grupo: {
    clave: string;
    label: string;
  }): Promise<void> {
    const eventos = this.eventosPorGrupo[grupo.clave] ?? [];
    if (!eventos.length) {
      this.helper.notifWarn('No hay eventos para tratar');
      return;
    }
    const config: MatDialogConfig = {
      data: {
        titulo: grupo.label,
        idsEventos: eventos.map((e) => e._id),
        // Cuando el criterio es expresable, el dialogo puede tratar el grupo
        // completo en vez de solo lo cargado.
        query: this.queryDelGrupo(grupo.clave),
        totalEnBase: this.truncadoPersonalizado
          ? this.totalCountPersonalizado
          : undefined,
      },
      minWidth: '600px',
      maxWidth: '800px',
      disableClose: true,
    };
    const dialogRef = this.formularios.abrir(TratamientoGrupalComponent, {
      tamano: 'mediano',
      data: config.data,
    });
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) await this.listarPersonalizado();
  }

  private async finalizarTodos(idsEventos: string[]) {
    if (idsEventos.length === 0) {
      this.helper.notifWarn('No hay eventos para finalizar');
      return;
    }
    const filter: IFilter<IEventoGenerico> = {
      _id: { $in: idsEventos },
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      includeChildren: true,
    };
    const update: any = {
      estado: 'Finalizada',
    };
    try {
      this.loading = true;
      const res = await this.eventosGenericosService.updateMany2(query, update);
      this.helper.notifSuccess('Eventos finalizados correctamente');
      await this.listadoVivoService.forceRefresh();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    } finally {
      this.loading = false;
    }
  }

  /**
   * Obtiene la información de entidad (icono y texto) para mostrar en la tabla.
   * Cacheada por evento: se llama por fila en cada ciclo de detección.
   */
  public obtenerEntidadInfo(
    element: IEventoGenerico,
  ): { icono: string; texto: string } | null {
    if (this.cacheEntidadInfo.has(element)) {
      return this.cacheEntidadInfo.get(element);
    }
    const info = this.calcularEntidadInfo(element);
    this.cacheEntidadInfo.set(element, info);
    return info;
  }

  private calcularEntidadInfo(
    element: IEventoGenerico,
  ): { icono: string; texto: string } | null {
    if (element.alarma?.nombre) {
      return { icono: 'doorbell', texto: element.alarma.nombre };
    } else if (element.activo?.identificacion) {
      let icono = 'assistant_navigation';
      if (element.tipoEvento === 'Evento Vehiculo') {
        icono = 'directions_car';
      } else if (element.tipoEvento === 'Evento Colectivo') {
        icono = 'directions_bus';
      }
      return { icono, texto: element.activo.identificacion };
    } else if (element.tracker?.identificacion) {
      return { icono: 'gps_fixed', texto: element.tracker.identificacion };
    } else if (element.luminaria?.identificacion) {
      return { icono: 'lightbulb', texto: element.luminaria.identificacion };
    } else if (element.gateway?.nombre || element.gateway?.nombreChirpstack) {
      return {
        icono: 'podcasts',
        texto: element.gateway.nombre || element.gateway.nombreChirpstack,
      };
    } else if (element.botonBluetooth?.mac) {
      return { icono: 'touch_app', texto: element.botonBluetooth.mac };
    } else if (element.sirena?._id) {
      return { icono: 'campaign', texto: element.sirena.chipId };
    }
    return null;
  }

  ngOnDestroy(): void {
    this.eventos$?.unsubscribe();
    this.personalizado$?.unsubscribe();
    this.busquedaSub?.unsubscribe();
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.busquedaSub = this.busqueda$
      .pipe(debounceTime(200))
      .subscribe(() => this.aplicarFiltro());
    // El modo queda guardado: si el operador dejo el personalizado, arranca ahi
    if (this.modoAgrupacion === '6') {
      await this.listarPersonalizado();
      return;
    }
    await this.listar();
  }
}
